import type { ReactNode } from "react";
import { Icon, type IconName } from "./icon";

// Toast, ported from the prototype's styles.css `.toast` (bottom-centre,
// dark pill, slide-up animation). Presentational — callers control mount/
// auto-dismiss, matching the prototype's `onToast` pattern.
export interface ToastProps {
  message: ReactNode;
  icon?: IconName;
}

export function Toast({ message, icon = "checkCircle" }: ToastProps) {
  return (
    <div className="toast" role="status" aria-live="polite">
      {icon && <Icon name={icon} size={17} />}
      <span>{message}</span>
    </div>
  );
}
